/**
 * Keeps --pinned-announcement-height in sync with the rendered height of any
 * pinned announcement bar(s) (sections/header-announcements.liquid,
 * pin_to_top setting). sections/header.liquid reads this custom property so
 * the sticky header docks directly beneath a pinned bar instead of
 * overlapping it. (RET-187)
 */
function updatePinnedAnnouncementHeight() {
  let height = 0;

  document.querySelectorAll('.announcement-bar--pinned').forEach((element) => {
    height += element.getBoundingClientRect().height;
  });

  document.body.style.setProperty('--pinned-announcement-height', `${Math.round(height)}px`);
}

const pinnedBars = document.querySelectorAll('.announcement-bar--pinned');

if (pinnedBars.length) {
  const resizeObserver = new ResizeObserver(updatePinnedAnnouncementHeight);
  pinnedBars.forEach((element) => resizeObserver.observe(element));
  updatePinnedAnnouncementHeight();
}
